import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Toolbar from '../App/Toolbar';
import AppStore from '../../stores/AppStore';
import Snackbar from 'material-ui/Snackbar';
import AddEntityButton from './AddEntityButton';
import AddEntityActionButton from './AddEntityActionButton';
import SpeedDial from './SpeedDial';

/**
 *
 * DetailView component
 */
class DetailView extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            successMessageDuration: 1500,
            showSuccessMessage: false,
            showErrorMessage: false,
            showFormMessages: false,
            showProgress: false,
            canSubmit: false,
            lastErrorMessage: ''
        };
    }

    componentDidMount() {
        this.onErrorMessage = this.onErrorMessage.bind(this);
        this.onFormSubmitSuccess = this.onFormSubmitSuccess.bind(this);
        this.handleSnackbarRequestClose = this.handleSnackbarRequestClose.bind(this);

        AppStore.addFormSubmitErrorListener(this.onErrorMessage);
        AppStore.addFormSubmitSuccessListener(this.onFormSubmitSuccess);
    }

    componentWillUnmount() {
        AppStore.removeFormSubmitErrorListener(this.onErrorMessage);
        AppStore.removeFormSubmitSuccessListener(this.onFormSubmitSuccess);
    }

    render() {

        let snackbars;

        if (this.props.showFormMessages) {
            snackbars = [
                <Snackbar key="successMessage"
                    open={this.state.showSuccessMessage}
                    message="Saved"
                    autoHideDuration={this.state.successMessageDuration}
                    onRequestClose={this.handleSnackbarRequestClose}
                />,
                <Snackbar key="errorMessage"
                    open={this.state.showErrorMessage}
                    message={this.state.lastErrorMessage}
                    action="OK"
                    onActionTouchTap={this.handleSnackbarRequestClose}
                    onRequestClose={this.handleSnackbarRequestClose}
                />
            ];
        }

        let newEntityButton;
        if(this.props.newEntityUrl) {
            newEntityButton = <AddEntityButton newEntityUrl={this.props.newEntityUrl} />;
        } else if (this.props.newEntityAction) {
            newEntityButton = <AddEntityActionButton onClick={this.props.newEntityAction} />;
        } else if (this.props.newEntityActions) {
            newEntityButton = <SpeedDial actions={this.props.newEntityActions} />;
        }

        return (
            <div>
                <Toolbar
                    title={this.props.title}
                    actions={this.props.actions}
                    backButton={this.props.backButton}
                    backTo={this.props.backTo}
                    forceBack={this.props.forceBack}
                    searchAction={this.props.searchAction}
                />
                <div className='cent-main'>
                    {this.props.children}
                </div>
                {snackbars}
                {newEntityButton}
            </div>
        );
    }

    handleSnackbarRequestClose() {
        this.setState({ showSuccessMessage: false, showErrorMessage: false } );
    }

    onErrorMessage() {
        if (this.props.showFormMessages) {
            this.setState({
                showProgress: false,
                showErrorMessage: true,
                lastErrorMessage: AppStore.getLastError()
            });
        }
    }

    onFormSubmitSuccess() {
        if (this.props.showFormMessages) {
            this.setState({
                showProgress: false,
                showSuccessMessage: true
            });
        }
    }

}

DetailView.propTypes = {
    backButton:         PropTypes.bool,
    backTo:             PropTypes.string,
    forceBack:          PropTypes.bool,
    showFormMessages:   PropTypes.bool,
    newEntityUrl:   PropTypes.string,
    newEntityAction: PropTypes.func,
    newEntityActions: PropTypes.arrayOf(
        PropTypes.shape({
            label:      PropTypes.string.isRequired,
            link:       PropTypes.string,
            icon:       PropTypes.object
        })
    ),
    title: PropTypes.string,
};

DetailView.defaultProps = {
    backButton:         false,
    backTo:             null,
    forceBack:          false,
    showFormMessages:   false,
    title: '',
};

export default DetailView;
